import installation from './installation/texts.js';

export default {
  installation,
  selectDialog: {
    title: {
      notes:
        'Title of the dialog listing the screen deck configs one can be opened from',
      message: 'Open config',
    },
  },
  overview: {
    weight: {
      notes:
        'Title of the total weight KPI card in the configuration overview shown when no panels are selected',
      message: 'Weight',
    },
    total: {
      notes: 'Subtitle of the weight KPI card, the value is a total',
      message: 'Total',
    },
    workingDepth: {
      notes:
        'Title of the working depth KPI card in the configuration overview shown when no panels are selected',
      message: 'Working depth',
    },
    apertureWidth: {
      notes:
        'Title of the aperture width KPI card in the configuration overview shown when no panels are selected',
      message: 'Aperture width',
    },
    average: {
      notes:
        'Subtitle of the working depth and aperture width KPI cards, the value is an average',
      message: 'Avg',
    },
    materialComposition: {
      notes:
        'Heading of the table listing the screening media of the configuration and how many panels use each',
      message: 'Material composition',
    },
    panelsColumn: {
      notes:
        'Column header for the number of panels using a screening media in the material composition table',
      message: 'Panels',
    },
    noPanels: {
      notes:
        'Shown instead of the material composition table when the configuration has no panels',
      message: 'No panels configured.',
    },
  },
  details: {
    moreFields: {
      notes:
        'Label of the mini button in a deck layout header that expands the panel with the config name and labels fields',
      message: 'More fields',
    },
    generalInformation: {
      header: {
        notes: 'Header for general information accordion',
        message: 'General information',
      },
    },
    layout: {
      header: {
        notes: 'Header for layout accordion',
        message: 'Layout',
      },
    },
  },
  model: {
    updatedAt: {
      notes: 'Field updatedAt for screen deck configs',
      message: 'Last updated',
    },
    deckName: {
      notes: 'Field deckName for screen deck configs',
      message: 'Deck',
    },
    labels: {
      notes: 'Field labels for screen deck configs',
      message: 'Labels',
    },
    name: {
      notes: 'Field name for screen deck configs',
      message: 'Name',
    },
    installationPeriod: {
      notes: 'Field installationPeriod for screen deck configs',
      message: 'Installation period',
    },
    installed: {
      notes: 'Field installed for screen deck configs',
      message: 'Installed',
    },
    columns: {
      notes: 'Field columns for screen deck configs',
      message: 'Columns',
    },
    rows: {
      notes: 'Field rows for screen deck configs',
      message: 'Rows',
    },
    creator: {
      notes: 'Field creator for screen deck configs',
      message: 'Creator',
    },
  },
};
